
import {callApi} from './http';

//後台帳戶
export function create_manager(payload) {
  return callApi('post','sign/backend-up', payload)
}
export function edit_manager(payload) {
  return callApi('post','sign/backend-edit', payload)
}
export function get_manager_list(payload) {
  return callApi('post','sign/backend-search', payload)
}
export function remove_manager(payload) {
  return callApi('post','sign/backend-delete', payload)
}

//用戶組
export function create_group(payload) {
  return callApi('post','role/create', payload)
}
export function edit_group(payload) {
  return callApi('post','role/update', payload)
}
export function get_group_list(payload) {
  return callApi('post','role/search', payload)
}
export function remove_group(payload) {
  return callApi('post','role/delete', payload)
}
export function get_group_info(payload) {
  return callApi('post','role/info', payload)
}


export function update_session_last(payload){
  return callApi('post','user/update-lasted',payload,{
    disableLoading:true
  });
}
